const cityCache = new Map()

/**
 * Fetch and cache cities for a given UF (state)
 *
 * @param {Object} api Axios instance
 * @param {string} uf State abbreviation (e.g. 'SP')
 * @returns {Promise<string[]>} List of city names
 */
export const getCitiesByUf = async (api, uf) => {
    if (!uf || typeof uf !== 'string') {
        return []
    }

    const state = uf.trim().toUpperCase()
    if (!state) {
        return []
    }

    if (cityCache.has(state)) {
        return cityCache.get(state)
    }

    try {
        const response = await api.get('/ibge_cities', {
            params: { uf: state }
        })

        const data = response.data
        const members = data && data['hydra:member'] ? data['hydra:member'] : (Array.isArray(data) ? data : [])
        const cities = members.map(item => (typeof item === 'object' && item.city ? item.city : item))

        cityCache.set(state, cities)
        return cities
    } catch (error) {
        console.error('Failed to load IBGE cities for state ' + state, error)
        return []
    }
}

/**
 * Clear in-memory city cache
 */
export const clearCityCache = () => {
    cityCache.clear()
}

export default {
    getCitiesByUf,
    clearCityCache
}
